export const isPortfolioManaged = (groupId?: string) => {
  return groupId === "26";
};
